import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null)
    return (
      <div className="flex items-center justify-center min-h-screen bg-zinc-50">
        <div className="text-zinc-500 text-sm tracking-widest uppercase">Loading…</div>
      </div>
    );
  if (user === false)
    return <Navigate to="/login" state={{ from: location }} replace />;
  if (roles && !roles.includes(user.role) && user.role !== "admin")
    return <Navigate to="/dashboard" replace />;
  return children;
}
